// define api endpoint here
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

export const API_LOGIN = '/digital/login'
export const API_LOGOUT = '/digital/logout'
// MAGAZINE
export const API_GET_MAGAGINE = '/digital/magazines'
export const API_GET_MAGAZINE_PURCHASE = '/digital/purchasedMagazines'
export const API_GET_MAGAGINE_DETAIL = '/clients/magazine-details/:id'

// HISTORY
export const API_GET_HISTORY = API_GET_MAGAGINE + '/history'
// APP
export const API_APP_SETTING = '/clients/app-setting'
// bookmark
export const API_BOOKMARK = '/clients/magazine/pages'
// notification
export const API_NOTIFICATION = '/clients/notifications'
// log
export const API_LOGS = '/device-logs'
// get url
export const API_GET_URL_MAGAZINE = '/clients/magazine-url/:magazine_id'
// expand-token
export const API_EXPAND_TOKEN = '/digital/expand-token-expire'
// action
export const API_ACTION_MAGAZINE = '/cms/magazine/:magazineId/action-setting'
export const API_ACTION_MAGAZINE_DETAIL = '/cms/magazine/:magazineId/action-setting/:actionId'
